module.exports = __webpack_public_path__ + "img/icon1-1-1024x1024.46d090b6.png";